module.exports = __webpack_public_path__ + "static/media/Palmeiras.ea04ad19.svg";